import { render } from "./ImagePlus.vue?vue&type=template&id=5b0e15f7"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ImagePlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b0e15f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b0e15f7', __exports__)) {
    api.reload('5b0e15f7', __exports__)
  }
  
  module.hot.accept("./ImagePlus.vue?vue&type=template&id=5b0e15f7", () => {
    api.rerender('5b0e15f7', render)
  })

}


export default __exports__